// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LixVL","option":"styles_option__eppcg","active":"styles_active__3QLmN"};